import React from "react";
import { HashRouter } from 'react-router-dom';  // Change to HashRouter
import { AuthWrapper } from './auth/AuthWrapper';

function App() {
  return (
    <div className="App">
      <HashRouter>  {/* Changed BrowserRouter to HashRouter */}
        <AuthWrapper />
      </HashRouter>      
    </div>
  );
}

export default App;
